import SecureUserTokenService, { UserToken } from './SecureUserTokenService';

import config from '../context/config/config';

class AuthService {
  private brokerId: string | null = null;

  constructor(
    private secureTokenService: SecureUserTokenService = new SecureUserTokenService(),
  ) {}

  initialize() {
    this.brokerId = config.broker_uid;
  }

  getBrokerId(): string {
    return this.brokerId ?? '';
  }

  getUserToken(): UserToken | undefined {
    return this.secureTokenService.get();
  }

  getAccessToken(): string {
    const userToken = this.secureTokenService.get();
    return userToken?.accessToken ?? '';
  }

  setUserToken(userToken: UserToken) {
    this.secureTokenService.set(userToken);
  }

  clearUserToken() {
    this.secureTokenService.clear();
  }
}

export default AuthService;
